(function () {
  'use strict';

  var bar = document.querySelector('.odms26summer-stickytabbar');
  if (!bar) return;

  var floatingbar = document.querySelector('.odms26summer-stickytabbar__floatingbar');
  var scrollCta = bar.querySelector('.odms26summer-stickytabbar__scroll-cta');
  var header = document.querySelector('.odms26summer-header');

  // Placeholder reserves the bar's in-flow height while it switches to
  // position:fixed. Without it the page reflows by the bar height the moment the
  // bar becomes fixed, which (a) makes content visibly jump and (b) makes the
  // anchor scroll land at a different spot depending on scroll direction
  // (the reflow only happens when scrolling down into the sticky zone). Keeping
  // the layout stable removes both problems.
  var placeholder = document.createElement('div');
  placeholder.className = 'odms26summer-stickytabbar__placeholder';
  placeholder.setAttribute('aria-hidden', 'true');
  placeholder.style.display = 'none';
  if (bar.parentNode) bar.parentNode.insertBefore(placeholder, bar.nextSibling);

  // Scroll-spy map: section id -> tab id
  var sections = [
    { id: 'Odms-Vorteile-Section', tabId: 'Odms-Tab-Vorteile' },
    { id: 'Odms-Stundenplan-Section', tabId: 'Odms-Tab-Stundenplan' },
    { id: 'Odms-Zertifikat-Section', tabId: 'Odms-Tab-Zertifikat' },
    { id: 'OMR24-Alumni-Section', tabId: 'Odms-Tab-Alumni' },
    { id: 'Pdp-FAQ-Section', tabId: 'Odms-Tab-Faq' },
  ];

  // Extra gap (px) below the sticky bar when scrolling to a section. 0 = the
  // section's top edge sits flush against the bar for a lean, tight look; each
  // section's own padding-top then sets the distance to its headline. Mobile
  // only — desktop keeps native scrollIntoView.
  var MOBILE_SCROLL_OFFSET = 0;

  function scrollToTarget(id) {
    var el = document.getElementById(id);
    if (!el) return;

    if (window.innerWidth <= 1024) {
      var offset = bar.offsetHeight + MOBILE_SCROLL_OFFSET;
      var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    } else {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // Tab clicks — replaces inline onClick + the old global scrollToTop.
  bar.querySelectorAll('[data-scroll-target]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // prevent Prestige theme.js from hijacking the scroll
      scrollToTarget(el.getAttribute('data-scroll-target'));
    });
  });

  function setActiveTab() {
    var closestId = null;
    var closestDistance = Infinity;

    sections.forEach(function (s) {
      var section = document.getElementById(s.id);
      if (!section) return;
      var distance = Math.abs(section.getBoundingClientRect().top);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestId = s.id;
      }
    });

    sections.forEach(function (s) {
      var tab = document.getElementById(s.tabId);
      if (!tab) return;
      tab.classList.toggle('odms26summer-stickytabbar__tab--current', s.id === closestId);
    });
  }

  function setSticky(on) {
    if (on) {
      // Reserve the bar's height in flow *before* it leaves the flow.
      if (placeholder.style.display === 'none') {
        placeholder.style.height = bar.offsetHeight + 'px';
        placeholder.style.display = 'block';
      }
      bar.classList.add('odms26summer-stickytabbar--sticky');
    } else {
      bar.classList.remove('odms26summer-stickytabbar--sticky');
      placeholder.style.display = 'none';
    }
  }

  function stickyNavbar() {
    // Use the placeholder's in-flow position as the threshold so it stays stable
    // regardless of whether the bar is currently fixed.
    var ref = placeholder.style.display !== 'none' ? placeholder : bar;
    var sticky = ref.offsetTop;
    var unSticky = header ? header.offsetHeight : 0;

    if (window.pageYOffset >= sticky && window.pageYOffset > unSticky) {
      setSticky(true);
      if (window.innerWidth > 1024 && scrollCta) scrollCta.style.display = 'flex';
    } else {
      setSticky(false);
      if (scrollCta) scrollCta.style.display = 'none';
    }

    if (window.innerWidth <= 1024 && floatingbar) {
      floatingbar.style.display = window.pageYOffset >= unSticky ? 'flex' : 'none';
    }
  }

  window.addEventListener('scroll', function () {
    stickyNavbar();
    setActiveTab();
  });
  window.addEventListener('resize', function () {
    setActiveTab();
  });

  setActiveTab();
})();
